package com.macrofocus.eflux.context

enum class ActiveTooltip {
    Nodes {
        override val nodes: Boolean = true
        override val links: Boolean = false
    },

    Links {
        override val nodes: Boolean = false
        override val links: Boolean = true
    },

    Both {
        override val nodes: Boolean = true
        override val links: Boolean = true
    },

    None {
        override val nodes: Boolean = false
        override val links: Boolean = false
    };

    abstract val nodes: Boolean
    abstract val links: Boolean
}